import LocalStorageConstants from 'client/util/Constants/LocalStorageConstants';
import SignupConstants from 'client/util/Constants/SignupConstants';

/**
 * Create Constants object that can be referenced globally
 * instead of magic numbers or strings
 */
export default {
  environments: {
    local: 'local',
    staging: 'staging',
    production: 'production',
  },
};

export const LocalStorageConsts = LocalStorageConstants;
export const SignupConsts = SignupConstants;

/**
 * Default values for XMLHttpRequests
 */
export const XhrConsts = {
  CSRFInputName: '_csrf',
  XsrfInputName: '_xsrf',
  xCSRFToken: 'X-CSRF-Token',
  xOrgIdHeader: 'X-Org-Id',
  xOrgIdKey: 'jc-orgId',
  xTotalCount: 'X-Total-Count',
  xXsrfToken: 'X-Xsrftoken',
};

/**
 * the routeGenerator should be used to keep track of the routes used across
 * the login pages. This was created in order to avoid any potential spelling
 * mistakes when redirecting.
 */
export const RouteGenerator = {
  adminPortalLandingPage: '/#/home',
  mtpLandingPage: '/mtp',
  login: '/login/admin',
  signup: '/signup',
  userPortalLogin: '/login',
};
